/**
 * The chatbot's contact settings (ADR-0110), as widget-config sends them:
 * the extra fields of "leave a message" and the WhatsApp number. Drawn,
 * never trusted: anything out of the contract's shape is dropped and the
 * form stays as it always was.
 */

const KEY = /^f\d{1,10}$/;
const NUMBER = /^[1-9]\d{7,14}$/;
const TYPES = ['text', 'number', 'date', 'time', 'email', 'phone', 'choice'];

const short = (value, max) => typeof value === 'string' && value.trim() !== '' && value.length <= max;

/** `contact_form` cleaned to the contract, or null. */
export function normalizeContactForm(form) {
  if (!form || typeof form !== 'object') return null;
  const intro = typeof form.intro === 'string' && form.intro.length <= 500 ? form.intro.trim() : '';
  const fields = [];
  for (const field of Array.isArray(form.fields) ? form.fields.slice(0, 6) : []) {
    if (!field || !KEY.test(field.key) || !short(field.label, 60) || !TYPES.includes(field.type)) continue;
    const clean = { key: field.key, label: field.label.trim(), type: field.type, required: field.required === true };
    if (field.type === 'choice') {
      clean.options = (Array.isArray(field.options) ? field.options.slice(0, 12) : [])
        .filter((option) => option && short(option.value, 60) && short(option.label, 60))
        .map((option) => ({ value: option.value, label: option.label.trim() }));
      if (!clean.options.length) continue;
    }
    fields.push(clean);
  }
  return intro || fields.length ? { intro, fields } : null;
}

/**
 * The wa.me link for `whatsapp` of widget-config, or null. `{site}` in the
 * greeting is the page's host; an empty greeting is the widget's own.
 */
export function whatsappUrl(whatsapp, fallbackGreeting, host) {
  if (!whatsapp || typeof whatsapp !== 'object' || !NUMBER.test(whatsapp.number || '')) return null;
  const own = typeof whatsapp.greeting === 'string' && whatsapp.greeting.length <= 200 ? whatsapp.greeting.trim() : '';
  const text = (own || fallbackGreeting || '').split('{site}').join(host || '');
  return `https://wa.me/${whatsapp.number}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}

/**
 * The input for one extra field: its element and attributes. Native
 * controls, so a phone gets its keypad and a date its calendar.
 */
export function controlFor(field) {
  switch (field.type) {
    case 'number':
      return { tag: 'input', attrs: { type: 'text', inputmode: 'decimal', maxlength: '20' } };
    case 'date':
      return { tag: 'input', attrs: { type: 'date' } };
    case 'time':
      return { tag: 'input', attrs: { type: 'time' } };
    case 'email':
      return { tag: 'input', attrs: { type: 'email', maxlength: '254', autocomplete: 'email' } };
    case 'phone':
      return { tag: 'input', attrs: { type: 'tel', maxlength: '20', autocomplete: 'tel' } };
    case 'choice':
      return { tag: 'select', attrs: {} };
    default:
      return { tag: 'input', attrs: { type: 'text', maxlength: '500' } };
  }
}
